import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from "@angular/core";
import { CatagoryServiceService } from "../catagory-service.service";
import { environment } from "../../environments/environment";
import { RouterLink } from "@angular/router";
import { LazyImgDirective } from "../lazy-img.directive";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "app-new-screen-seven",
  templateUrl: "./new-screen-seven.component.html",
  styleUrls: ["./new-screen-seven.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RouterLink, LazyImgDirective, MatButton]
})
export class NewScreenSevenComponent implements OnInit {
  conv_image: any;
  env = environment;

  constructor(
    private service: CatagoryServiceService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.ppt();
  }
  ppt() {
    this.service.the_last_word_iages().subscribe(data => {
      let da = data;
      if (da["success"]) {
        this.conv_image = da["data"];
      }
      this.cdr.markForCheck();
    });
  }
}
